<template lang="html">
<div style="background-color: black; height: 100%;" id="land-container" @click="imageReturn($event)">
  <!-- <v-parallax
  :src="headerImage"
  height="250"
  > -->
  <div class="header-container">
    <v-container class="parallax-container-center">
      <v-layout justify-center align-center class="header-layout">
        <v-flex xs12 sm10 md8 lg8 xl8>
          <h1 class="parallax-middle-header">Land-Based Games</h1>

          <br>
          <p>Land-Based games are played at casinos in Las Vegas and worldwide. &nbsp;View a sample of our extensive game library and patented features.</p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
  <!-- </v-parallax> -->

  <v-container v-if="!viewAll && !mobile">
    <v-layout>
      <v-flex xs12>
        <slick
          ref="slick"
          :options="slickOptions"
        >
          <v-flex
            v-for="(image, i) in defaultImages"
            :key="i"
          >
            <!-- <v-hover> -->
              <!-- <v-card flat tile slot-scope="{ hover }"> -->
              <v-card flat tile>
                <!-- <v-img
                  :aspect-ratio="16/9"
                  :src="image"
                  :lazy-src="image"
                  :id="`image${i}`"
                  @mouseenter="enter(i)"
                  @mouseleave="leave(i)"
                  style="background-color: black;"
                > -->
                <img
                  :id="`image${i}`"
                  class="hoverOpacityLess fade-in-on-load"
                  width="100%"
                  :src="image"
                  :alt="localJson[i].Game"
                  @click="clickLessImage(i)"
                >
                  <template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                    <v-expand-transition>
                      <!-- <div
                      v-if="hover && i === 0"
                      class="d-flex transition-fast-in-fast-out grey darken-4 v-card--reveal subtitle white--text hoverStyle"
                      id="image0"
                      >
                      <strong>Snow Day!</strong>
                      <span>Free Spins with Guaranteed Wilds!</span>
                    </div> -->
                    <!-- v-if="hover" -->
                    <div style="height: 100%; opacity: 1;" class="v-card--reveal" @click="clickLessImage(i)" v-if="clickImageLess && !sameImageShow && clickIndex === i">
                      <img
                        :id="`image${i}`"
                        class="fade-in-on-load-hover"
                        width="100%"
                        :src="hoverImages[i]"
                        :alt="localJson[i].Game"
                      >
                      <div
                        v-if="clickImageLess && !sameImageShow && clickIndex === i"
                        class="d-flex transition-fast-in-fast-out grey darken-4 v-card--reveal subtitle white--text"
                        style="height: 20%;"
                        :id="`image${i}`"
                      >
                      <v-container class="carousel-container">
                        <v-layout xs12>
                          <v-flex xs12>
                            <p style="font-size: 0.8vw; margin: 0;"><strong>{{ localJson[i].Game }}</strong></p>
                            <p style="font-size: 0.65vw; margin: 0;">{{ localJson[i].Text }}</p>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                  </div>
                  </v-expand-transition>
                <!-- </v-img> -->
              </v-card>
            <!-- </v-hover> -->
          </v-flex>
        </slick>
      </v-flex>
    </v-layout>
  </v-container>

  <v-container fluid v-else-if="viewAll && !mobile">
    <v-layout justify-center fluid>
      <v-flex xs12 justify-center>
        <v-container grid-list-xs justify-center wrap fluid>
          <!-- The Modal -->
          <div id="myModal" class="modal" @click="modalClose($event)">
            <!-- The Close Button -->
            <span class="close" @click="modalClose">&times;</span>
            <!-- Modal Content (The Image) -->
            <img class="modal-content" id="img01" :style="`background: url(${this.spinner}) transparent center no-repeat;`">
            <!-- Modal Caption (Image Text) -->
            <div id="caption"></div>
          </div>
          <v-layout row wrap>
            <v-flex
              v-for="(image, i) in defaultImages"
              :key="i"
              xs12 sm6 md4 lg4
            >
              <!-- <img
                :id="`image${i}`"
                class="hoverOpacity lazy"
                v-lazy="image"
                width="100%"
                :alt="localJson[i].Game"
                @click="clickImage(i)"
              > -->
              <!-- <v-hover> -->
                <!-- <v-card flat tile slot-scope="{ hover }" class="hoverCards"> -->
                <v-card flat tile>
                  <!-- <v-img
                    :aspect-ratio="16/9"
                    :src="image"
                    :lazy-src="image"
                    :id="`image${i}`"
                    @mouseenter="enter(i)"
                    @mouseleave="leave(i)"
                    class="zoom"
                  > -->
                  <img
                    :id="`image${i}`"
                    class="hoverOpacity fade-in-on-load"
                    width="100%"
                    height="100%"
                    :src="image"
                    :alt="localJson[i].Game"
                    @click="clickLessImage(i)"
                  >
                    <template v-slot:placeholder>
                      <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>

                    <v-expand-transition>
                      <!-- v-if="hover" -->
                      <div style="height: 100%; opacity: 1;" class="v-card--reveal" @click="clickLessImage(i)" v-if="clickImageLess && !sameImageShow && clickIndex === i">
                        <img
                          :id="`image${i}`"
                          class="fade-in-on-load-hover"
                          width="100%"
                          height="100%"
                          :src="hoverImages[i]"
                          :alt="localJson[i].Game"
                        >
                      <div
                        v-if="clickImageLess && !sameImageShow && clickIndex === i"
                        class="d-flex transition-fast-in-fast-out grey darken-4 v-card--reveal subtitle white--text"
                        style="height: 20%;"
                        :id="`image${i}`"
                      >
                        <v-container class="carousel-container">
                          <v-layout xs12>
                            <v-flex xs12>
                              <p style="font-size: 0.8vw; margin: 0;"><strong>{{ localJson[i].Game }}</strong></p>
                              <p style="font-size: 0.65vw; margin: 0;">{{ localJson[i].Text }}</p>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </div>
                      </div>
                    </v-expand-transition>
                  <!-- </v-img> -->
                </v-card>
              <!-- </v-hover> -->
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>

  <v-container fluid v-else>
    <v-layout justify-center fluid>
      <v-flex xs12 justify-center>
        <v-container grid-list-xs justify-center wrap fluid>
          <!-- <v-layout row wrap>
            <v-flex
              v-for="(image, i) in defaultImages"
              :key="i"
              xs12 sm6 md4 lg4
            >
              <v-hover>
                <v-card flat tile slot-scope="{ hover }">
                  <v-img
                    :aspect-ratio="16/9"
                    :src="image"
                    :lazy-src="image"
                    :id="`image${i}`"
                    @mouseenter="enter(i)"
                    @mouseleave="leave(i)"
                    style="background-color: black;"
                  >
                    <template v-slot:placeholder>
                      <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out grey darken-4 v-card--reveal subtitle white--text"
                      style="height: 100%;"
                      :id="`image${i}`"
                    >
                      <v-container>
                        <v-layout xs12>
                          <v-flex xs12>
                            <p class="title"><strong>{{ localJson[i].Game }}</strong></p>
                            <p>{{ localJson[i].Text }}</p>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                  </v-expand-transition>
                  </v-img>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout> -->
          <!-- The Modal -->
          <div id="myModal" class="modal" @click="mobileModalClose" v-touch="{ left: () => mobileModalClose(), right: () => mobileModalClose(), up: () => mobileModalClose(), down: () => mobileModalClose() }">
            <!-- The Close Button -->
            <span class="close" @click="modalClose">&times;</span>
            <!-- Modal Content (The Image) -->
            <img class="modal-content" id="img01" :style="`background: url(${this.spinner}) transparent center no-repeat;`">
            <!-- Modal Caption (Image Text) -->
            <div id="caption"></div>
          </div>
          <v-layout row wrap>
            <v-flex
              v-for="(image, i) in defaultImages"
              :key="i"
              xs12 sm6 md4 lg4
            >
              <img
                :id="`image${i}`"
                class="mobileBorder lazy"
                v-lazy="image"
                width="100%"
                :alt="localJson[i].Game"
                @click="clickImage(i)"
              >
            </v-flex>
            </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>

  <v-btn round outline large dark @click.native="viewBtnClick" v-if="!viewAll && !mobile" class="viewBtn">View More</v-btn>
  <v-btn round outline large dark @click.native="viewBtnClick" v-else-if="viewAll && !mobile" class="viewBtn">View Less</v-btn>
</div>
</template>

<script>
import Slick from 'vue-slick'
// import fileCSV from '../../assets/ksg-csv.csv'
import gamesJson from '../../assets/ksg-games-updated.json'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
  components: {
    Slick
  },
  data () {
    return {
      placeholder: require('../../assets/placeholder.jpg'),
      spinner: require('../../assets/spinner.gif'),
      click: false,
      currentCard: 0,
      // localCSV: fileCSV,
      localJson: gamesJson,
      slickOptions: {
        slidesToShow: 3,
        slidesToScroll: 3,
        // dots: true,
        arrows: true,
        infinite: true
      },
      images: [
        // require('../assets/thumbnails/Thumb_BlackStallion.jpg'),
        require('../../assets/thumbnails/Thumb_SnowDay.jpg'),
        require('../../assets/thumbnails/Thumb_FirePearl.jpg'),
        require('../../assets/thumbnails/Thumb_FishingBob.jpg'),
        require('../../assets/thumbnails/Thumb_HotRoll.jpg'),
        require('../../assets/thumbnails/Thumb_JadeFortune.jpg'),
        require('../../assets/thumbnails/Thumb_Lobstermania.jpg')
      ],
      headerImage: require('../../assets/Land-Based Games/Header_LandBasedGames.png'),
      defaultImages: [
        require('../../assets/Land-Based Games/DG/LuckyLarryLobstermania3_DG.png'),
        require('../../assets/Land-Based Games/DG/HotRollMultiplierDrawPoker_DG.png'),
        require('../../assets/Land-Based Games/DG/LuckyBuddha_DG.png'),
        require('../../assets/Land-Based Games/DG/DoubleBigWheel3510Play_DG.png'),
        require('../../assets/Land-Based Games/DG/PlaySplitCardDrawPoker_DG.png'),
        require('../../assets/Land-Based Games/DG/BuffaloStorm_DG.png'),
        require('../../assets/Land-Based Games/DG/Big5Safari_DG.png'),
        require('../../assets/Land-Based Games/DG/Big5Cats_DG.png'),
        require('../../assets/Land-Based Games/DG/PyramidProgressives_DG.png'),
        require('../../assets/Land-Based Games/DG/PigPug_DG.png'),
        require('../../assets/Land-Based Games/DG/CelticMagic_DG.png'),
        require('../../assets/Land-Based Games/DG/WolfPeak_DG.png'),
        require('../../assets/Land-Based Games/DG/WuDaJiang_DG.png'),
        require('../../assets/Land-Based Games/DG/LuckyLarryLobstermaniaClassic_DG.png'),
        require('../../assets/Land-Based Games/DG/FishingBob2_DG.png'),
        require('../../assets/Land-Based Games/DG/PrinceOfThieves_DG.png'),
        require('../../assets/Land-Based Games/DG/DragonStorm_DG.png'),
        require('../../assets/Land-Based Games/DG/MysteryOfTheCongo_DG.png'),
        require('../../assets/Land-Based Games/DG/TripleBigWheel6x4x3x2xVIP_DG.png'),
        require('../../assets/Land-Based Games/DG/LegendOfChange_DG.png'),
        require('../../assets/Land-Based Games/DG/Lulu&Luigi_DG.png'),
        require('../../assets/Land-Based Games/DG/LuckyStudDrawPoker_DG.png'),
        require('../../assets/Land-Based Games/DG/PyramidPoker_DG.png'),
        require('../../assets/Land-Based Games/DG/SuperRich_DG.png'),
        require('../../assets/Land-Based Games/DG/DarkAndStormy_DG.png'),
        require('../../assets/Land-Based Games/DG/MegaFreeGamesDophinBay_DG.png'),
        require('../../assets/Land-Based Games/DG/FarmersDaughter_DG.png'),
        require('../../assets/Land-Based Games/DG/TurquoisePrincess_DG.png'),
        require('../../assets/Land-Based Games/DG/FishingBob1_DG.png'),
        require('../../assets/Land-Based Games/DG/JadeFortune_DG.png'),
        require('../../assets/Land-Based Games/DG/FirePearl_DG.png'),
        require('../../assets/Land-Based Games/DG/LegendsOfAsgard_DG.png'),
        require('../../assets/Land-Based Games/DG/LuckyLarryLobstermania2_DG.png'),
        require('../../assets/Land-Based Games/DG/SnowDay_DG.png'),
        require('../../assets/Land-Based Games/DG/GhostIsland_DG.png'),
        require('../../assets/Land-Based Games/DG/WeddingParty_DG.png'),
        require('../../assets/Land-Based Games/DG/PhoneTag_DG.png'),
        require('../../assets/Land-Based Games/DG/Shrimpmania_DG.png'),
        require('../../assets/Land-Based Games/DG/PriceCheck_DG.png'),
        require('../../assets/Land-Based Games/DG/Crabmania_DG.png'),
        require('../../assets/Land-Based Games/DG/WildForDolphins_DG.png'),
        require('../../assets/Land-Based Games/DG/NurseFollies_DG.png'),
        require('../../assets/Land-Based Games/DG/StateFair_DG.png'),
        require('../../assets/Land-Based Games/DG/HotPokerDiceJokerPoker_DG.png'),
        require('../../assets/Land-Based Games/DG/HotRollFeverPoker_DG.png'),
        require('../../assets/Land-Based Games/DG/DoubleDoubleComboDrawPoker_DG.png'),
        require('../../assets/Land-Based Games/DG/ComboDrawPoker_DG.psd.png'),
        require('../../assets/Land-Based Games/DG/MovinOnUpPoker_DG.png'),
        require('../../assets/Land-Based Games/DG/3SacredTreasures_DG.jpg'),
        require('../../assets/Land-Based Games/DG/CherryCashFreeGames_DG.jpg'),
        require('../../assets/Land-Based Games/DG/DesertJewel_DG.jpg'),
        require('../../assets/Land-Based Games/DG/FengShuiDragon_DG.jpg'),
        require('../../assets/Land-Based Games/DG/FishOnAlaskanKing_DG.jpg'),
        require('../../assets/Land-Based Games/DG/FishOnUltimateCatch_DG.jpg'),
        require('../../assets/Land-Based Games/DG/GreatAndBeautifulGoldenEmpress_DG.jpg'),
        require('../../assets/Land-Based Games/DG/HolyGuacamole_DG.jpg'),
        require('../../assets/Land-Based Games/DG/LuckyHot7sFreeGames_DG.jpg'),
        require('../../assets/Land-Based Games/DG/LuckyWealthCat_DG.jpg'),
        require('../../assets/Land-Based Games/DG/MysteryOfTheClockwork_DG.jpg'),
        require('../../assets/Land-Based Games/DG/PowerOfCash_DG.jpg'),
        require('../../assets/Land-Based Games/DG/ShadowMasquerade_DG.jpg'),
        require('../../assets/Land-Based Games/DG/ToucanTropics_DG.jpg'),
        require('../../assets/Land-Based Games/DG/WizardRiches_DG.jpg'),
        require('../../assets/Land-Based Games/DG/WildPinataCC_DG.jpg'),
        require('../../assets/Land-Based Games/DG/SWMTreasureFish_DG.jpg'),
        require('../../assets/Land-Based Games/DG/TigerEmpire_DG.jpg'),
        require('../../assets/Land-Based Games/DG/GoldenRoseCC_DG.jpg'),
        require('../../assets/Land-Based Games/DG/PharaohsOfTheNile_DG.jpg'),
        require('../../assets/Land-Based Games/DG/SuperHotRollPoker_DG.jpg'),
        require('../../assets/Land-Based Games/DG/FreddyTheLawnFlamingo_DG.jpg'),
        require('../../assets/Land-Based Games/DG/DragonsVsPandas_DG.jpg')
      ],
      hoverImages: [
        require('../../assets/Land-Based Games/EGM/LuckyLarryLobstermania3_EGM.png'),
        require('../../assets/Land-Based Games/EGM/HotRollMultiplierDrawPoker_EGM.png'),
        require('../../assets/Land-Based Games/EGM/LuckyBuddha_EGM.png'),
        require('../../assets/Land-Based Games/EGM/DoubleBigWheel3510Play_EGM.png'),
        require('../../assets/Land-Based Games/EGM/PlaySplitCardDrawPoker_EGM.png'),
        require('../../assets/Land-Based Games/EGM/BuffaloStorm_EGM.png'),
        require('../../assets/Land-Based Games/EGM/Big5Safari_EGM.png'),
        require('../../assets/Land-Based Games/EGM/Big5Cats_EGM.png'),
        require('../../assets/Land-Based Games/EGM/PyramidProgressives_EGM.png'),
        require('../../assets/Land-Based Games/EGM/PigPug_EGM.png'),
        require('../../assets/Land-Based Games/EGM/CelticMagic_EGM.png'),
        require('../../assets/Land-Based Games/EGM/WolfPeak_EGM.png'),
        require('../../assets/Land-Based Games/EGM/WuDaJiang_EGM.png'),
        require('../../assets/Land-Based Games/EGM/LuckyLarryLobstermaniaClassic_EGM.png'),
        require('../../assets/Land-Based Games/EGM/FishingBob2_EGM.png'),
        require('../../assets/Land-Based Games/EGM/PrinceOfThieves_EGM.png'),
        require('../../assets/Land-Based Games/EGM/DragonStorm_EGM.png'),
        require('../../assets/Land-Based Games/EGM/MysteryOfTheCongo_EGM.png'),
        require('../../assets/Land-Based Games/EGM/TripleBigWheel6x4x3x2xVIP_EGM.png'),
        require('../../assets/Land-Based Games/EGM/LegendOfChange_EGM.png'),
        require('../../assets/Land-Based Games/EGM/Lulu&Luigi_EGM.png'),
        require('../../assets/Land-Based Games/EGM/LuckyStudDrawPoker_EGM.png'),
        require('../../assets/Land-Based Games/EGM/PyramidPoker_EGM.png'),
        require('../../assets/Land-Based Games/EGM/SuperRich_EGM.png'),
        require('../../assets/Land-Based Games/EGM/Dark&Stormy_EGM.png'),
        require('../../assets/Land-Based Games/EGM/MegaFreeGamesDophinBay_EGM.png'),
        require('../../assets/Land-Based Games/EGM/FarmersDaughter_EGM.png'),
        require('../../assets/Land-Based Games/EGM/TurquoisePrincess_EGM.png'),
        require('../../assets/Land-Based Games/EGM/FishingBob1_EGM.png'),
        require('../../assets/Land-Based Games/EGM/JadeFortune_EGM.png'),
        require('../../assets/Land-Based Games/EGM/FirePearl_EGM.png'),
        require('../../assets/Land-Based Games/EGM/LegendsOfAsgard_EGM.png'),
        require('../../assets/Land-Based Games/EGM/LuckyLarryLobstermania2_EGM.png'),
        require('../../assets/Land-Based Games/EGM/SnowDay_EGM.png'),
        require('../../assets/Land-Based Games/EGM/GhostIsland_EGM.png'),
        require('../../assets/Land-Based Games/EGM/WeddingParty_EGM.png'),
        require('../../assets/Land-Based Games/EGM/PhoneTag_EGM.png'),
        require('../../assets/Land-Based Games/EGM/Shrimpmania_EGM.png'),
        require('../../assets/Land-Based Games/EGM/PriceCheck_EGM.png'),
        require('../../assets/Land-Based Games/EGM/Crabmania_EGM.png'),
        require('../../assets/Land-Based Games/EGM/WildForDolphins_EGM.png'),
        require('../../assets/Land-Based Games/EGM/NurseFollies_EGM.png'),
        require('../../assets/Land-Based Games/EGM/StateFair_EGM.png'),
        require('../../assets/Land-Based Games/EGM/HotPokerDiceJokerPoker_EGM.png'),
        require('../../assets/Land-Based Games/EGM/HotRollFeverPoker_EGM.png'),
        require('../../assets/Land-Based Games/EGM/DoubleDoubleComboDrawPoker_EGM.png'),
        require('../../assets/Land-Based Games/EGM/ComboDrawPoker_EGM.png'),
        require('../../assets/Land-Based Games/EGM/MovinOnUpPoker_EGM.png'),
        require('../../assets/Land-Based Games/EGM/3SacredTreasures_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/CherryCashFreeGames_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/DesertJewel_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/FengShuiDragon_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/FishOnAlaskanKing_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/FishOnUltimateCatch_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/GreatAndBeautifulGoldenEmpress_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/HolyGuacamole_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/LuckyHot7sFreeGames_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/LuckyWealthCat_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/MysteryOfTheClockwork_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/PowerOfCash_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/ShadowMasquerade_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/ToucanTropics_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/WizardRiches_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/WildPinataCC_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/SWMTreasureFish_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/TigerEmpire_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/GoldenRoseCC_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/PharaohsOfTheNile_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/SuperHotRollPoker_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/FreddyTheLawnFlamingo_EGM.jpg'),
        require('../../assets/Land-Based Games/EGM/DragonsVsPandas_EGM.jpg')
      ],
      viewAll: false,
      clickImageLess: false,
      clickIndex: 0,
      prevIndex: null,
      imageCounter: 0
    }
  },
  computed: {
    mobile () {
      return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ||
        navigator.userAgent.toLowerCase().indexOf('android') > -1
    },
    sameImageShow () {
      return this.imageCounter % 2 === 0
    }
  },
  methods: {
    imageReturn (ev) {
      if (!this.mobile) {
        let imageId = ev.target.attributes[1] ? ev.target.attributes[1].value : ''
        if (!imageId.includes('image')) {
          this.clickImageLess = false
          this.imageCounter = 0
        }
      }
    },
    clickLessImage (index) {
      this.clickImageLess = true

      if (this.clickIndex === index) {
        this.imageCounter++
      } else {
        this.clickIndex = index
        this.imageCounter = 1
      }

      // if (this.prevIndex !== null && this.prevIndex !== this.clickIndex) {
      //   let prev = document.querySelector(`#image${this.prevIndex}`)
      //   prev.src = this.defaultImages[this.prevIndex]
      //   prev.srcset = this.defaultImages[this.prevIndex]
      //
      //   this.prevIndex = index
      // } else if (this.prevIndex === null) {
      //   this.prevIndex = index
      // }
      //
      // let el = document.querySelector(`#image${index}`)
      // el.src = this.hoverImages[index]
      // el.srcset = this.hoverImages[index]
    },
    next () {
      this.$refs.slick.next()
    },
    prev () {
      this.$refs.slick.prev()
    },
    reInit () {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },
    enter (i) {
      // let el = document.querySelector(`#image${i}`)
      // let image = this.hoverImages[i]
      // el.src = image
      // el.srcset = image
      let el = document.querySelector(`#image${i} div.v-image__image--cover`)
      el.style.backgroundImage = 'url(' + this.hoverImages[i] + ')'
      // setTimeout(function(){debugger}, 3000)
    },
    leave (i) {
      // let el = document.querySelector(`#image${i}`)
      // let image = this.defaultImages[i]
      // el.src = image
      // el.srcset = image
      let el = document.querySelector(`#image${i} div.v-image__image--cover`)
      el.style.backgroundImage = 'url(' + this.defaultImages[i] + ')'
    },
    viewBtnClick () {
      this.viewAll = !this.viewAll
    },
    clickImage (index) {
      // this.click = !this.click
      // this.currentCard = index
      //
      // if (this.click) {
      //   let el = document.querySelector(`#image${index} div.v-image__image--cover`)
      //   el.style.backgroundImage = 'url(' + this.hoverImages[index] + ')'
      // } else {
      //   let el = document.querySelector(`#image${index} div.v-image__image--cover`)
      //   el.style.backgroundImage = 'url(' + this.defaultImages[index] + ')'
      // }

      // Get the modal
      let modal = document.getElementById('myModal')

      // Get the image and insert it inside the modal - use its "alt" text as a caption
      // let img = document.getElementById(`image${index}`);
      let modalImg = document.getElementById('img01')
      let captionText = document.getElementById('caption')
      let game = this.localJson[index].Game
      let description = this.localJson[index].Text

      modalImg.classList.add('zoomBlock')
      captionText.classList.add('zoomBlock')
      modal.style.display = 'block'
      modalImg.src = this.hoverImages[index]
      captionText.innerHTML = `
        <h1><strong>${game}</strong></h1>
        <p>${description}</p>
      `

      const targetElement = document.querySelector('#land-container')
      disableBodyScroll(targetElement)
    },
    modalClose (ev) {
      // console.log(ev.srcElement.attributes[1].value)
      // for firefox close
      if (navigator.userAgent.indexOf('Firefox') > 0) {
        if (ev.srcElement.classList[0] !== 'modal-content') {
          let modal = document.getElementById('myModal')
          let image = document.getElementById('img01')
          let caption = document.getElementById('caption')

          if (image.classList.contains('zoomBlock')) {
            image.classList.remove('zoomBlock')
            image.classList.add('zoomNone')
          }
          if (caption.classList.contains('zoomBlock')) {
            caption.classList.remove('zoomBlock')
            caption.classList.add('zoomNone')
          }
          setTimeout(() => {
            image.classList.remove('zoomNone')
            caption.classList.remove('zoomNone')
            modal.style.display = 'none'
          }, 300)
        }
      } else {
        let el = ev.path[0]
        if (!el.classList.contains('modal-content')) {
          let modal = document.getElementById('myModal')
          let image = document.getElementById('img01')
          let caption = document.getElementById('caption')

          if (image.classList.contains('zoomBlock')) {
            image.classList.remove('zoomBlock')
            image.classList.add('zoomNone')
          }
          if (caption.classList.contains('zoomBlock')) {
            caption.classList.remove('zoomBlock')
            caption.classList.add('zoomNone')
          }
          setTimeout(() => {
            image.classList.remove('zoomNone')
            caption.classList.remove('zoomNone')
            modal.style.display = 'none'
          }, 300)
        }
      }
      // Get the <span> element that closes the modal
      // let span = document.getElementsByClassName('close')[0]
      // Get the modal
      // When the user clicks on <span> (x), close the modal
      // span.onclick = function () {
      // }
    },
    mobileModalClose () {
      let modal = document.getElementById('myModal')
      let image = document.getElementById('img01')
      let caption = document.getElementById('caption')

      if (image.classList.contains('zoomBlock')) {
        image.classList.remove('zoomBlock')
        image.classList.add('zoomNone')
      }
      if (caption.classList.contains('zoomBlock')) {
        caption.classList.remove('zoomBlock')
        caption.classList.add('zoomNone')
      }
      setTimeout(() => {
        image.classList.remove('zoomNone')
        caption.classList.remove('zoomNone')
        modal.style.display = 'none'

        const targetElement = document.querySelector('#land-container')
        enableBodyScroll(targetElement)
      }, 300)
    }
  },
  mounted () {
    // console.log(this.localJson)
  },
  beforeMount () {
    // this.$papa.parse(localCSV, {
    //   header: true,
    //   complete: function (results, file) {
    //     console.log(results)
    //   }
    // })
    if (this.mobile) {
      this.viewAll = true
    }
  }
}
</script>

<style lang="scss" scoped>
.parallax-container-center {
  // width: 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
}

.parallax-middle-header {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2.7rem;
  align-self: stretch;
}

.slick-prev:before, .slick-next:before {
  color: white !important;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .8;
  position: absolute;
  width: 100%;
}

.header-container {
  background-image: url('../../assets/Land-Based Games/Header_LandBasedGames.png');
}

.header-layout {
  margin: 2rem 0;
}

.viewBtn {
  margin-bottom: 10rem;
}

// .hoverStyle {
//   height: 30%;
//   flex-direction: column;
// }

.carousel-container {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0;
}

.theme--light.v-sheet {
  border: 5px solid black;
  background-color: black;
}
// .hoverCards {
  // height: 100%;
  // opacity: 1;
  // -webkit-transition: opacity .5s;
  // -moz-transition: opacity .5s;
  // transition: opacity .5s;
// }
//
// .hoverCards:hover {
//   opacity: 0.5;
// }

.zoom {
  transition: transform .35s;
  background-color: black;
  -ms-transform: scale(1.5); /* IE 9 */
  -webkit-transform: scale(1.5); /* Safari 3-8 */
  transform: scale(1.5);
  z-index: 10;
  opacity: 1;
}

.hoverOpacity {
  // border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  // border: 5px solid black;
}

.hoverOpacity:hover {
  opacity: 0.7;
}

.mobileBorder {
  border: 5px solid black;
  border-radius: 5px;
}

.hoverOpacityLess {
  transition: 0.3s;
  border: 5px solid black;
}

.hoverOpacityLess:hover {
  opacity: 0.8;
}

// .zoom:hover {
//   -ms-transform: scale(1.5); /* IE 9 */
//   -webkit-transform: scale(1.5); /* Safari 3-8 */
//   transform: scale(1.5);
//   z-index: 10;
//   opacity: 1;
// }

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  padding-top: 10rem; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 1200px;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 1200px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

/* Add Animation - Zoom in the Modal */
.modal-content, #caption {
  // animation-name: zoom;
  // animation-duration: 0.6s;
}

.zoomBlock {
  animation: zoom 0.6s ease 1;
}

.zoomNone {
  animation: zoomout 0.6s ease 1;
}

@keyframes zoom {
  from {transform:scale(0)}
  to {transform:scale(1)}
}

@keyframes zoomout {
  from {transform:scale(1)}
  to {transform:scale(0)}
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

@keyframes fadeInOnLoad {
  0%, 50% {
    opacity: 0;
    filter: blur(20px);
  }
  100% {
    opacity: 1;
    filter: blur(0px);
  }
}

@keyframes fadeInOnLoadHover {
  0% {
    opacity: 0;
    filter: blur(20px);
  }
  100% {
    opacity: 1;
    filter: blur(0px);
  }
}

.fade-in-on-load {
  animation-name: fadeInOnLoad;
  animation-duration: 1.5s
}

.fade-in-on-load-hover {
  animation-name: fadeInOnLoadHover;
  animation-duration: 0.5s;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
  .modal-content {
    width: 100%;
  }
}
</style>
